import {
    SET_DASHBOARD_DATA
} from '../actions/types';
import axios from 'axios';

export const setDashboardData = (options = {}) => {
    return async (dispatch,getState) => {
        const data = await axios.get(`/api/dashboard/getDashboardData/${options.modelName}${options.search||''}`);
        dispatch({
            type: SET_DASHBOARD_DATA,
            payload: data.data
        })

        await axios.get(`/api/dashboard/getLastEditedOn/${options.modelName}`)
        .then(lastEditData => {
            dispatch({
                type: 'SET_LAST_EDITED_ON',
                payload: {
                    lastEditedOn : lastEditData.data.lastEditedOn
                }
            })
        })
        
    };
};

export const addRemoveColumn = (column_name) => {
    return {
        type: 'TOGGLE_DASHBOARD_COLUMN',
        payload:column_name
    };
}
